import React from 'react';
import WaitCube from '../../WaitCube.js'
import {_GPY,__GPYPost , __GPYGet} from '../../env.js'
import RightLinks from '../../RightLinks.js'

class UserSubscription extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
     buyMode: false,
     userCheck: false,
     isCurrentUserLoaded:false,
     checkAccept1: false,
     checkAccept6: false,
     checkAccept12: false,
     agreement: {id:-1},
   };
  }

  componentDidMount() {
    __GPYGet('getAgreement',(res)=>{
          this.setState({agreement:res.PaymentAgreement});
    });
    this.checkUser();
  }

  checkUser(){
    __GPYGet('getUser',(res)=>{
      var usr = res.User
      if(usr.street===undefined||usr.street===""){
        this.setState({userCheck:true,isCurrentUserLoaded:true});
        return;
      }
      if(usr.streetNr===undefined||usr.streetNr===""){
        this.setState({userCheck:true,isCurrentUserLoaded:true});
        return;
      }
      if(usr.city===undefined||usr.city===""){
        this.setState({userCheck:true,isCurrentUserLoaded:true});
        return;
      }
      if(usr.zipcode===undefined||usr.zipcode===""){
        this.setState({userCheck:true,isCurrentUserLoaded:true});
        return;
      }
      if(usr.locale===undefined||usr.locale===""){
        this.setState({userCheck:true,isCurrentUserLoaded:true});
        return;
      }
      this.setState({userCheck:false,isCurrentUserLoaded:true});

    },(res)=>{
      this.setState({userCheck:true,isCurrentUserLoaded:false});
    });
  }

  onPaypal(plan){
    this.setState({buyMode:true},() => {
          __GPYPost('pay',{paymentType:"paypal",paymentPlan:plan},(res)=>{
              // console.log(res.List.paypalApprovalUrl);
              window.location.href=res.PaymentAgreement.paypalApprovalUrl;
          },(err)=>{
                this.setState({buyMode:true});
          });
    });
  }
  setGameType(f){
     this.props.setGameType(f);
  }

  cancel(){
    __GPYPost('cancelAgreement',{id:this.state.agreement.id},(res)=>{
       window.location.reload(false);
    });
  }

  toggleAccept(plan){
    var states = this.state;
    var val = !this.state["checkAccept"+plan];
    if(val) {
      states.checkAccept1 = false;
      states.checkAccept6 = false;
      states.checkAccept12 = false;
      states["checkAccept"+plan] = val;
    } else {
      states.checkAccept1 = false;
      states.checkAccept6 = false;
      states.checkAccept12 = false;
    }
    this.setState(states);
  }

	render() {

    if(!this.state.isCurrentUserLoaded) {
        return (<WaitCube/>);


    } if(this.state.userCheck) {


      return (
        <div className="row justify-content-center pt-5">

          <div className="col-4">
            <div className="jumbotron">
              <h1>{_GPY.i18n.get('UserSubscription_userwarn_title')}</h1>
              <p className="lead pt-4">{_GPY.i18n.get('UserSubscription_userwarn_info')}</p>
              <p className="pb-5"><a href={"https://www.guppyi.com/prices/?lang="+_GPY.locale} rel="noopener noreferrer" target="_blank">{_GPY.i18n.get('UserSubscription_userwarn_subscription_infomation_link')}</a></p>

              <button className="btn btn-primary btn-lg" onClick={this.setGameType.bind(this,"UserAccount")}>{_GPY.i18n.get('UserSubscription_userwarn_button')}</button>
            </div>
          </div>

       </div>);


    } else if(this.state.buyMode) {


      return (
        <div className="row justify-content-center pt-5">
          <div className="col-4 col-md-6">
                      <div className="row shadow bg-light border border-secondary rounded">
                        <div className="col-12 p-5 text-center">
                          <img alt="paypal logo" className="img-fluid" src="https://www.paypalobjects.com/webstatic/de_DE/i/de-pp-logo-200px.png"/>
                        </div>

                        <div className="col-12 text-center">
                          <p className="text-center">{_GPY.i18n.get('UserSubscription_paypal_wait_info')}</p>
                        </div>
                        <div className="col-12 p-5"><WaitCube/></div>
                      </div>
          </div>
       </div>);


    } else if(this.state.agreement.id > 0) {


      return (
        <div className="row justify-content-center pt-5">
          <div className="col-4 col-md-6">
                      <div className="row shadow bg-light border border-secondary rounded">

                        <div className="col-12 p-5 text-center">
                          <img alt="paypal logo" className="img-fluid" src="https://www.paypalobjects.com/webstatic/de_DE/i/de-pp-logo-200px.png"/>
                        </div>
                        <div className="col-12 text-center">
                           <p>{_GPY.i18n.get('UserSubscription_paypal_cancel_aboinfo')} { this.state.agreement.subscriptionDays }</p>
                           <p>{_GPY.i18n.get('UserSubscription_paypal_cancel_next_subscription_info')} {this.state.agreement.nextLookup}</p>
                        </div>
                        {this.state.agreement.state.toLowerCase()==="active"?
                        <div className="col-12 text-center p-5">
                          <button className="btn btn-primary btn-lg" onClick={this.cancel.bind(this)}>{_GPY.i18n.get('UserSubscription_paypal_cancel_button')}</button>
                        </div>
                        :""}
                        <div className="col-12 text-center p-5">
                           {this.state.agreement.state}
                        </div>
                      </div>
          </div>
       </div>
      );
    } else {

      return (
        <div>
          <div className="row">
            <div className="col-12 pt-2">
                <div className="card bg-light">
                    <div className="card-header">{_GPY.i18n.get('UserSubscription_create_title')}</div>

                    <div className="card-body">
                      <div className="row pt-3"><div className="col-12">{_GPY.i18n.get('UserSubscription_create_info')}</div></div>

                        <div className="row pt-5">

                          <div className="col-4" style={{paddingTop:"15px"}}>
                              <div className="card border-secondary">
                                  <div className="card-header"><h2>{_GPY.i18n.get('UserSubscription_create_1_title')}</h2></div>

                                  <div className="card-body">
                                        <div className="row">
                                          <div className="col-12" style={{height:"300px",paddingTop:"15px"}}>
                                          <ul>
                                            <li className="text-danger">{_GPY.i18n.get('UserSubscription_create_1_list_0')} </li>
                                            <li>{_GPY.i18n.get('UserSubscription_create_1_list_1')}</li>
                                            <li>{_GPY.i18n.get('UserSubscription_create_1_list_2')}</li>
                                            <li>{_GPY.i18n.get('UserSubscription_create_1_list_3')}</li>
                                            <li>{_GPY.i18n.get('UserSubscription_create_1_list_4')}</li>
                                          </ul>
                                          </div>
                                        </div>

                                        <div className="row pt-3">
                                        <div className="col-12" >
                                            <div class="form-check form-check-inline">
                                              <input className="form-check-input" type="checkbox" id="inlineCheckbox1" onClick={this.toggleAccept.bind(this,"1")} checked={this.state.checkAccept1}/>
                                              <label className="form-check-label" htmlFor="inlineCheckbox1">{_GPY.i18n.get('UserSubscription_create_checkbox_title')}</label>
                                            </div>
                                        </div>
                                        <div className="col-12"><RightLinks/></div>
                                          <div className="col-12 pt-2">
                                            {this.state.checkAccept1?
                                              <button type="button"  onClick={this.onPaypal.bind(this,"1")} className="btn btn-secondary btn-lg btn-block">{_GPY.i18n.get('UserSubscription_create_1_button')}</button>
                                            :
                                              <button type="button"className="btn btn-secondary btn-lg btn-block disabled">{_GPY.i18n.get('UserSubscription_create_1_button')}</button>
                                            }
                                          </div>

                                        </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-4">
                              <div className="card border-primary">
                                  <div className="card-header"><h2>{_GPY.i18n.get('UserSubscription_create_12_title')}</h2></div>
                                  <div className="card-body">
                                      <div className="row">
                                        <div className="col-12"  style={{height:"330px"}}>
                                        <ul>
                                        <li className="text-danger">{_GPY.i18n.get('UserSubscription_create_12_list_0')} </li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_12_list_1')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_12_list_2')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_12_list_3')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_12_list_4')}</li>
                                        </ul>
                                        </div>
                                      </div>

                                      <div className="row pt-3">
                                      <div className="col-12" >
                                          <div class="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox6" onClick={this.toggleAccept.bind(this,"12")} checked={this.state.checkAccept12}/>
                                            <label className="form-check-label" htmlFor="inlineCheckbox6">{_GPY.i18n.get('UserSubscription_create_checkbox_title')}</label>
                                          </div>
                                      </div>
                                      <div className="col-12"><RightLinks/></div>
                                        <div className="col-12 pt-2" >
                                          {this.state.checkAccept12?
                                            <button type="button" onClick={this.onPaypal.bind(this,"12")} className="btn btn-primary btn-lg btn-block">{_GPY.i18n.get('UserSubscription_create_12_button')}</button>
                                          :
                                            <button type="button"className="btn btn-primary btn-lg btn-block disabled">{_GPY.i18n.get('UserSubscription_create_12_button')}</button>
                                          }
                                        </div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-4" style={{paddingTop:"15px"}}>
                              <div className="card border-info">
                                  <div className="card-header"><h2>{_GPY.i18n.get('UserSubscription_create_6_title')}</h2></div>
                                  <div className="card-body">
                                      <div className="row">
                                        <div className="col-12"  style={{height:"300px"}}>
                                        <ul>
                                        <li className="text-danger">{_GPY.i18n.get('UserSubscription_create_6_list_0')} </li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_6_list_1')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_6_list_2')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_6_list_3')}</li>
                                        <li>{_GPY.i18n.get('UserSubscription_create_6_list_4')}</li>
                                        </ul>
                                        </div>
                                      </div>

                                      <div className="row pt-3">
                                      <div className="col-12" >
                                          <div class="form-check form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox12" onClick={this.toggleAccept.bind(this,"6")} checked={this.state.checkAccept6}/>
                                            <label className="form-check-label" htmlFor="inlineCheckbox12">{_GPY.i18n.get('UserSubscription_create_checkbox_title')}</label>
                                          </div>
                                      </div>
                                      <div className="col-12"><RightLinks/></div>
                                        <div className="col-12 pt-2">
                                          {this.state.checkAccept6?
                                            <button type="button"  onClick={this.onPaypal.bind(this,"6")}  className="btn btn-info btn-lg btn-block">{_GPY.i18n.get('UserSubscription_create_6_button')}</button>
                                          :
                                            <button type="button"className="btn btn-info btn-lg btn-block disabled">{_GPY.i18n.get('UserSubscription_create_6_button')}</button>
                                          }
                                        </div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                        </div>
                    </div>
                </div>
             </div>
           </div>
        </div>

  		 	);

      }
    }
}
export default UserSubscription;
